import React from "react";
import { Button } from "react-bootstrap";
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import { scrollHelper } from "../helper/scrollHelper";
import { useRouter } from "next/router";
import Marquee from "react-fast-marquee";

import useEventListener from "../hooks/useEventListener";

function ButtonComponent({
  title,
  focusKey: FOCUS,
  type,
  onBtnClickHandler,
  disabled,
  marquee,
  headerComponent,
  locked,
  style,
}) {
  const router = useRouter();
  const { channel } = router.query;
  const { ref, focused, setFocus } = useFocusable({
    focusKey: FOCUS,
    onEnterPress: (e) => {
      // if (!disabled) {
      onBtnClickHandler(e, "enter");
      // }
      // if (!locked) {
      //   onBtnClickHandler(e, "enter");
      // }
    },
    onFocus: () => {
      scrollHelper(ref);
    },
    onArrowPress: (direction) => {
      // prevent focus lost on series
      if (FOCUS === "CATCH_UP" || FOCUS === "Movies" || FOCUS === "Series") {
        if (direction === "up") {
          return false;
        }
      }
      if (FOCUS === "Livetv") {
        if (direction === "up" || direction === "left") {
          return false;
        }
      }
    },
  });

  return (
    <div
      className={channel == title ? "Active-btn-div" : "btn-div"}
      style={{ overflow: "hidden" }}
    >
      <Button
        className={
          disabled && focused
            ? "Disabled_btn_focuse"
            : disabled
            ? "Disabled_btn"
            : focused
            ? "Active-button"
            : "Deactive-button"
          // disabled
          //   ? "Disabled_btn"
          //   : focused
          //   ? "Active-button"
          //   : "Deactive-button"
        }
        ref={ref}
        onClick={(e) => onBtnClickHandler(e, "click")}
        // type={type}
        disabled={disabled}
        style={{ boxShadow: "none" }}
      >
        {marquee && title?.length > 13 ? (
          <Marquee gradient={false} speed={65} className="marquee" delay={2}>
            {title == "CATCH_UP" ? "Catch up" : title}
          </Marquee>
        ) : title == "CATCH_UP" ? (
          "Catch up"
        ) : (
          title
        )}
        {channel == "Movies" && locked ? (
          <img
            src="/images/control/lock.svg"
            height={30}
            width={30}
            alt={"lock"}
          />
        ) : null}
      </Button>
    </div>
  );
}

export default React.memo(ButtonComponent);
